import { render, staticRenderFns } from "./GridCuadratura.vue?vue&type=template&id=2264e31a&"
import script from "./GridCuadratura.vue?vue&type=script&lang=js&"
export * from "./GridCuadratura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports